module.exports = __webpack_public_path__ + "img/DCI.82b028cb.png";